module.exports = __webpack_public_path__ + "b992c5a0bdcd0bef0f74ec98489f8bc3.jpg";